import { AssistantType } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'

export const supportAssistantRoute: RouteConfig = {
  path: '/support-assistant',
  name: 'support_assistant',
  component: () => import('../views/support/Assistant.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的助教',
  },
}

export const supportDownloadMaterialRoute: RouteConfig = {
  path: '/support-download-material',
  name: 'support_download_material',
  component: () => import('../views/support/DownloadMaterial.vue'),
  meta: {
    title: '体智云',
  },
}

export const supportInstructionRoute: RouteConfig = {
  path: '/support-instruction',
  name: 'support_instruction',
  component: () => import('../views/support/Instruction.vue'),
  meta: {
    title: '使用说明',
  },
}

export const supportQuestionDetailRoute: RouteConfig = {
  path: '/support-question-detail',
  name: 'support_question_detail',
  component: () => import('../views/support/QuestionDetail.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
}

export const supportFeedbackRoute: RouteConfig = {
  path: '/support-feedback',
  name: 'support_feedback',
  component: () => import('../views/support/Feedback.vue'),
}

const RSupport: RouteConfig[] = [
  supportAssistantRoute,
  supportDownloadMaterialRoute,
  supportInstructionRoute,
  supportQuestionDetailRoute,
  supportFeedbackRoute,
  {
    path: '/support-wechat-official-account',
    name: 'support_wechat_official_account',
    component: () => import('../views/support/WechatOfficialAccount.vue'),
    meta: {
      title: '体智云老师服务端',
    },
  },
  {
    path: '/support-new-year-greeting-2021',
    name: 'support_new_year_greeting_2021',
    component: () => import('../views/support/NewYearGreeting2021.vue'),
    meta: {
      title: '新春活动',
    },
  },
]

export default RSupport

export function navigateToSupportAssistant(router: VueRouter, assistantType = AssistantType.Auth) {
  router.push({ name: supportAssistantRoute.name, query: { assistantType } })
}

export function navigateToFeedback(router: VueRouter) {
  router.push({ name: supportFeedbackRoute.name })
}

export function redirectToSupportAssistant(router: VueRouter, assistantType = AssistantType.Auth) {
  router.push({ name: supportAssistantRoute.name, query: { assistantType } })
}
